export default "/institutions/xp.svg";